// extracted by mini-css-extract-plugin
export default {"main":"Base_layout_main__ailld","layout":"Base_layout_layout__Q+rWr","fade-in":"Base_layout_fade-in__IWW04"};